An error that occurred during position sync.
